// eslint-disable-next-line no-restricted-imports
import ReactShowdown, { MarkdownViewProps } from "react-showdown";
import { fontWeights } from "common/utils/styles";
import { colors, styled } from "../../../stitches.config";

export const MARKDOWN_STYLING = {
  fontSize: 14,
  lineHeight: "20px",
  strong: {
    fontWeight: fontWeights.bold,
  },
  gap: "8px 0",
  a: {
    color: colors.contentInfo,
  },
  p: { margin: "8px 0" },
  h1: {
    margin: "8px 0",
    fontSize: 20,
    fontWeight: fontWeights.extraBold,
  },
  h2: {
    margin: "8px 0",
    fontSize: 18,
    fontWeight: fontWeights.extraBold,
  },
  h3: {
    margin: "8px 0",
    fontSize: 16,
    fontWeight: fontWeights.bold,
  },
  h4: {
    margin: "8px 0",
    fontSize: 14,
    fontWeight: fontWeights.bold,
  },
  h5: {
    margin: "8px 0",
    fontSize: 12,
    fontWeight: fontWeights.bold,
  },
  ul: {
    marginBlock: 8,
    paddingInlineStart: 16,
    listStyleType: "disc", // Ensure lists within markdown are styled as first level even when any higher element is a ul
    li: {
      p: {
        margin: 0,
      },
      ul: {
        marginBlock: 0,
        listStyleType: "circle",
        li: {
          ul: {
            listStyleType: "square",
          },
        },
      },
    },
  },
  ol: {
    marginBlock: 8,
    paddingInlineStart: 16,
    listStyleType: "decimal", // Ensure lists within markdown are styled as first level even when any higher element is a ol
    li: {
      p: {
        margin: 0,
      },
      ol: {
        marginBlock: 0,
        listStyleType: "lower-alpha",
        li: {
          ol: {
            listStyleType: "lower-roman",
          },
        },
      },
    },
  },
};

const MarkdownView = (props: MarkdownViewProps) => (
  <ReactShowdown options={{ openLinksInNewWindow: true }} {...props} />
);

export const Markdown = styled(MarkdownView, {
  ...MARKDOWN_STYLING,
  variants: {
    tooltip: {
      true: {
        color: colors.contentSecondary,
        fontWeight: fontWeights.bold,
        maxWidth: "240px",
        overflowWrap: "break-word",
        p: {
          color: `${colors.contentPrimaryInverted.value} !important`,
          margin: "0",
        },
        a: {
          color: colors.contentInfoInverted,
        },
      },
    },
  },
});
